import { format, isToday, isTomorrow, isValid, parseISO } from 'date-fns';

export const getCutoffMessage = (cutoffDateTime: string | null): string | null => {
  if (!cutoffDateTime) {
    return null;
  }

  const cutoffDate = parseISO(cutoffDateTime);

  if (!isValid(cutoffDate)) {
    return null;
  }

  const time = format(cutoffDate, 'h:mm aa');

  if (isToday(cutoffDate)) {
    return `${time} today`;
  }

  if (isTomorrow(cutoffDate)) {
    return `${time} tomorrow`;
  }

  return null;
};
